import { AlertTickData } from './AlertTypes';
import { BookmarkTickData } from './BookmarkTypes';
import { NewsTickData } from './NewsTypes';
import { PublicOrderByLevelTickData, PublicOrderTickData, PublicTradeTickData } from './PublicTypes';
import { PrivateDataError, PrivateOrderTickData, PrivateTradeReportTickData, PrivateTradeTickData } from './PrivateTypes';

export const BY_LEVEL_SYMBOLS = ['ARION SDB', 'OSSR'];

export const isWithBookObject = <T extends TickData>(obj: T | WithBook<T>): obj is WithBook<T> => {
    if (obj === null || obj === undefined) return false;
    if (obj.hasOwnProperty('book') && obj.hasOwnProperty('tick')) {
        return true;
    }
    return false
}

export type WithBook<T> = {
    tick: T,
    book: Book
}

export type Book = {
    bookAskPrice: number | null
    bookAskQuantity: number | null
    bookBidPrice: number | null
    bookBidQuantity: number | null,
}


export type ByTradingDay<T> = {
    [tradingDay: string]: T | undefined
}

export type BySymbolByTradingDay<T> = {
    [symbol: string]: ByTradingDay<T> | undefined
}

export type BySymbolByDateRange<T> = {
    [symbol: string]: {
      [fromDate: string]: {
        [toDate: string]: T | undefined;
      } | undefined;
    } | undefined;
  };

export interface ISerializableError {
  message: string;
}

export type Fetched<T> = T | undefined | ISerializableError;
export type Requested<T> = T | 'waiting' | undefined | ISerializableError;
export type PrivateDataRequested<T> = T | 'waiting' | undefined | PrivateDataError;


export const changeBySymbolByTradingDayState = <T extends any, U extends PrivateDataRequested<T> | Requested<T>>(
    doubleMap: BySymbolByTradingDay<U>,
    symbol: string,
    tradingDay: string,
    newData: U
) => {
    // Copy Double Map.
    const bySymbolMapCopy = {...doubleMap};
    // Set if empty.
    if (bySymbolMapCopy?.[symbol] === undefined) {
        bySymbolMapCopy[symbol] = {};
    }
    // Copy Single map.
    const byTradingDayMapCopy = {...bySymbolMapCopy[symbol]};
    // Set data.
    byTradingDayMapCopy[tradingDay] = newData;
    // Put the copies back.
    bySymbolMapCopy[symbol] = byTradingDayMapCopy;
    // Return copy.
    return bySymbolMapCopy;
}

export const changeBySymbolByDateRangeState = <T>(
    state: BySymbolByDateRange<T>,
    symbol: string,
    fromDate: string,
    toDate: string,
    newData: T
  ): BySymbolByDateRange<T> => {
    // Copy the mapping for the symbol if it exists, or initialize it.
    const symbolMap = state[symbol] ? { ...state[symbol] } : {};
    // Copy the mapping for fromDate if it exists, or initialize it.
    const fromMap = symbolMap[fromDate] ? { ...symbolMap[fromDate] } : {};
    // Set the data for the given toDate.
    fromMap[toDate] = newData;
    // Put the updated fromMap back.
    symbolMap[fromDate] = fromMap;
    // Return the updated state.
    return {
      ...state,
      [symbol]: symbolMap,
    };
  };
  

export type TickData =
PublicOrderTickData
| PublicTradeTickData
| AlertTickData
| NewsTickData
| BookmarkTickData
| PrivateOrderTickData
| PrivateTradeTickData
| PrivateTradeReportTickData
| PublicOrderByLevelTickData;
